const {
	getRequest,
	postRequest,
	putRequest,
	deleteRequest,
} = require("./http-helper");
const api = "products";

const createProduct = (
	{
		allowedInstitutions,
		availableUnits,
		consumeEndDate,
		consumeStartDate,
		deliveryPricing,
		discountPercentage,
		hidden,
		institution,
		institutionName,
		isbns,
		levels,
		monthlyLimit,
		name,
		price,
		promotional = false,
		showForInstitutional,
		showForParticularStore,
		userType,
	},
	importMode = false
) => {
	return new Promise((resolve, reject) => {
		postRequest(
			`${api}${importMode ? "?import=true" : ""}`,
			{
				allowedInstitutions,
				availableUnits,
				consumeEndDate,
				consumeStartDate,
				deliveryPricing,
				discountPercentage,
				hidden,
				institution,
				institutionName,
				isbns,
				levels,
				monthlyLimit,
				name,
				price,
				promotional,
				showForInstitutional,
				showForParticularStore,
				userType,
			},
			resolve,
			reject,
			true
		);
	});
};

const updateProduct = (
	{
		_id,
		allowedInstitutions,
		availableUnits,
		consumeEndDate,
		consumeStartDate,
		deliveryPricing,
		discountPercentage,
		hidden,
		institution,
		institutionName,
		isbns,
		levels,
		monthlyLimit,
		name,
		price,
		promotional = false,
		showForInstitutional,
		showForParticularStore,
		userType,
	},
	code = false,
	importMode = false
) => {
	return new Promise((resolve, reject) => {
		const updateData = {
			allowedInstitutions,
			availableUnits,
			consumeEndDate,
			consumeStartDate,
			deliveryPricing,
			discountPercentage,
			hidden,
			institution,
			institutionName,
			isbns,
			levels,
			monthlyLimit,
			name,
			price,
			showForInstitutional,
			showForParticularStore,
			userType,
		};
		if (importMode && promotional) {
			updateData.promotional = true;
		}
		putRequest(
			`${api}/${code ? `code/${code}` : _id}${
				importMode ? "?import=true" : ""
			}`,
			updateData,
			resolve,
			reject,
			true
		);
	});
};

const deleteProduct = (id, code = false) => {
	return new Promise((resolve, reject) => {
		deleteRequest(`${api}/${code ? "code/" : ""}${id}`, resolve, reject, true);
	});
};

const getProductDetails = (id) => {
	return new Promise((resolve, reject) => {
		getRequest(`${api}/${id}`, resolve, reject, true);
	});
};

const sortProductsByLevel = (products, resolve) => {
	const productWithoutPriorityLevels = products.find(
		(product) => product?.levels?.length && !product.levels[0].priority
	);
	if (!productWithoutPriorityLevels) {
		products.sort((a, b) => {
			const firstPriority = a.levels?.length ? a.levels[0].priority : Infinity;
			const secondPriority = b.levels?.length ? b.levels[0].priority : Infinity;
			return firstPriority - secondPriority;
		});
	}
	resolve(products);
};

const getProducts = (
	level = null,
	institution = null,
	full = "",
	promotions = "false"
) => {
	return new Promise((resolve, reject) => {
		getRequest(
			`${api}?level=${level}&institution=${institution}&full=${full}&promotions=${promotions}`,
			resolve,
			reject,
			true,
			sortProductsByLevel
		);
	});
};

const getPublicProducts = (
	level = null,
	institution = null,
	full = "",
	promotions = "false",
	showForInstitutional = null,
	showForParticularStore = null
) => {
	return new Promise((resolve, reject) => {
		getRequest(
			`${api}/public?level=${level}&institution=${institution}${
				showForInstitutional ? "&showForInstitutional=true" : ""
			}&full=${full}&promotions=${promotions}${
				showForParticularStore ? "&showForParticularStore=true" : ""
			}`,
			resolve,
			reject,
			true,
			sortProductsByLevel
		);
	});
};

const importProducts = (importData) => {
	return new Promise((resolve, reject) => {
		postRequest(
			`${api}/import`,
			{ importProducts: importData },
			resolve,
			reject,
			true
		);
	});
};

module.exports = {
	createProduct,
	deleteProduct,
	getPublicProducts,
	getProductDetails,
	getProducts,
	updateProduct,
	importProducts,
};
